// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcs_a bhk_ea bhk_kb bhk_js bhk_sl bhk_wj"};